import { logo } from '../../../../data/logo'
import store from 'polotno/model/store'
import { getImageSize } from 'polotno/utils/image'
import { prefetch } from 'remotion'

async function addLogo(icon: any, index: number, selectedSize: string, store: any, visible:boolean) {
  const { waitUntilDone } = prefetch(icon, {
    method: 'blob-url',
    contentType: 'image/png',
  })
  await waitUntilDone()

  if (icon) {
    let { width, height } = await getImageSize(icon) as { width: number; height: number }

    const scaleFactor = selectedSize === '9:16' ? 0.4 : 0.2
    let scale = Math.min(store.width / width, store.height / height, scaleFactor)

    // Limit width to 250 pixels
    if (width * scale > 100) {
      scale *= 100 / (width * scale) // Adjust scale to fit within 250 width
    }

    // Ensure height is scaled proportionally
    height *= scale
    width *= scale

    store.pages[index].addElement({
      ...logo,
      id: 'quickadsLogo' + index.toString(),
      src: `${icon}`,
      x: store.width - width - 25,
      width: width,
      height: height,
      visible:visible,
      custom: {
        syncId: 'logoSync'
      }
    })
    const element = store.getElementById('quickadsLogo' + index.toString())
    element.set({ x: store.width - width - 25 })
  }
}

async function addCenterLogo(icon: any, index: number, selectedSize: string, store: any, visible: boolean) {
  const { waitUntilDone } = prefetch(icon, {
    method: 'blob-url',
    contentType: 'image/png',
  })
  await waitUntilDone()

  if (icon) {
    let { width, height } = await getImageSize(icon) as { width: number; height: number }

    const scaleFactor = selectedSize === '9:16' ? 0.4 : 0.2
    let scale = Math.min(store.width / width, store.height / height, scaleFactor)

    // Limit width to 250 pixels
    if (width * scale > 100) {
      scale *= 100 / (width * scale) // Adjust scale to fit within 250 width
    }

    // Ensure height is scaled proportionally
    height *= scale
    width *= scale

    // Calculate horizontal center and vertical position 35% from bottom
    const centerX = (store.width - width) / 2
    const yFromBottom = store.height * 0.35 // 35% from bottom
    const y = store.height - yFromBottom - height // Subtract height to position from bottom edge

    store.pages[index].addElement({
      ...logo,
      id: 'CenterLogo' + index.toString(),
      src: `${icon}`,
      x: centerX,
      y: y + 100,
      width: width,
      height: height,
      visible: visible,
      custom: {
        syncId: 'centerLogoSync'
      },
      borderRadius: 10,
      cornerRadius: 20
    })
  }
}

export { addLogo, addCenterLogo }
